import { CmsRecommendedActionsBlockLoadable } from './CmsRecommendedActionsBlockLoadable';

import type { CmsApiRecommendedActionsBlockData } from '#/modules/cms/api/types/blocks/CmsApiRecommendedActionsBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

export const CmsRecommendedActionsBlockMapping: CmsBlockMapping<CmsApiRecommendedActionsBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsRecommendedActionsBlockLoadable,
  };
